import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ui/index.css';
import App from './App';
import { installErrorCapture } from './utils/diagnostics';

// Before anything renders. A worker cannot read a console, so the report form
// carries the last few errors the app actually threw — and the ones that matter
// most are thrown during startup, before any component has mounted. Installed
// here rather than inside App so nothing is missed.
//
// Passive listeners only: React's error overlay and the browser console behave
// exactly as before. This observes, it does not swallow.
installErrorCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
